import * as Accordion from '@radix-ui/react-accordion';
import styled from '@emotion/styled';
import { Icon } from '@pairy/pds-react';

import { slideDown, slideUp } from '@/styles/keyframes/slide';

export const AccordionRoot = styled(Accordion.Root)`
  width: 100%;
`;

export const AccordionTrigger = styled(Accordion.Trigger)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const TriggerChevronIcon = styled(Icon)`
  [data-state='closed'] & {
    transform: rotate(180deg);
  }

  transition: transform 0.15s ease-in-out;
`;

export const AccordionContent = styled(Accordion.Content)`
  margin-top: 12px;

  &[data-state='closed'] {
    animation: ${slideUp('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
  }
  &[data-state='open'] {
    display: flex;
    flex-direction: column;
    animation: ${slideDown('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
    gap: 8px;
  }
`;
